import { Badge } from '@/components/ui/badge';
import { T } from 'gt-react';
import { LockSimple } from '@phosphor-icons/react';

/**
 * Shown on AR records that were synced from an external system (Famous, Plaid,
 * inbound email). These are read-only in the UI — the next sync would clobber
 * any in-app edit — so create/edit controls are hidden and this badge explains
 * why. Records with `originSystem === "manual"` are editable and omit it.
 */
export function OriginReadOnlyBadge({ className }: { className?: string }) {
  return (
    <Badge variant="outline" className={className}>
      <LockSimple className="mr-1 size-3" weight="bold" />
      <T context="badge, record synced from external system is read-only">
        Synced · read-only
      </T>
    </Badge>
  );
}

/** Convenience predicate mirroring the backend `isManualOrigin` guard. */
export function isManualOrigin(
  originSystem: string | null | undefined,
): boolean {
  return originSystem === 'manual';
}

/**
 * Cash receipts are editable when created by hand, extracted from email, or
 * created by a check deposit — mirrors the backend
 * `isEditableCashReceiptOrigin` guard. All are ingested once (never re-synced
 * from a periodic source), so an in-app correction is safe to keep. Do NOT use
 * this for payments/payment-applications, which stay manual-only.
 */
export function isEditableCashReceiptOrigin(
  originSystem: string | null | undefined,
): boolean {
  return (
    originSystem === 'manual' ||
    originSystem === 'email' ||
    originSystem === 'check_deposit'
  );
}
